var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "product-form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.addToCart.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "product-form__variant-select-wrapper" },
        [
          _c("select-input", {
            staticClass: "collection-grid__sort",
            attrs: {
              options: _vm.variantOptions,
              required: true,
              label: "Variant",
            },
            model: {
              value: _vm.currentSelectedVariantID,
              callback: function ($$v) {
                _vm.currentSelectedVariantID = $$v
              },
              expression: "currentSelectedVariantID",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "product-form__atc" },
        [
          _c("quantity-input", {
            staticClass: "product-form__quantity",
            attrs: { label: "Quantity", min: 1, max: _vm.remainingQuantity },
            model: {
              value: _vm.quantity,
              callback: function ($$v) {
                _vm.quantity = $$v
              },
              expression: "quantity",
            },
          }),
          _c("submit-button", {
            attrs: {
              label: _vm.buttonLabel,
              disabled: _vm.isDisabled,
              loading: _vm.adding,
              full: "",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }